/**
 * Poll cadence of the live Queue Status page. Throughput and the clear-time
 * estimates derive from CloudWatch, which does not publish faster than this,
 * so a tighter interval would re-render the same numbers at the cost of a
 * request per queue.
 */
export const POLL_INTERVAL_MS = 30_000;

/** How much history the page keeps; the sample cap derives from the cadence. */
export const HISTORY_WINDOW_MS = 3_600_000;

/**
 * Break the chart line when consecutive samples are further apart than this.
 * Polling stops while the tab is paused or hidden, and drawing one straight
 * segment across that gap would read as a smooth trend that was never sampled.
 */
export const MAX_SAMPLE_GAP_MS = POLL_INTERVAL_MS * 2.5;
